import React, { useEffect, useState } from "react";
import Card from "../../../../common/Card/Card";
import styles from "./CurrentRatio.module.scss";
import { getUsersInvestmentAction } from "../../../../../features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";

const CurrentRatio = () => {
  const spotPrice = useSelector((state) => state?.users?.spotPrice);
  const equityPrice = useSelector((state) => state?.users?.equityPrice);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1540);
  }, []);

  const dispatch = useDispatch();
  const [quantityOrder, setQuantityOrder] = useState(false);
  const [data, setData] = useState();
  const [listData, setListData] = useState({});

  const getUsersInvestment = async (data) => {
    try {
      let params = {};
      const response = await dispatch(getUsersInvestmentAction(params));
      if (response?.status === 200) {
        const userData = response.data.data?.getUserInvestments;
        setData(userData);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  useEffect(() => {
    getUsersInvestment();
  }, []);

  useEffect(() => {
    const newList = {};
    if (data?.tokenSales) {
      for (const item of data?.tokenSales) {
        const key = item.name?.replace(/\s/g, "");
        newList[key] = item;
      }
    }
    setListData(newList);
  }, [data]);

  return (
    <Card
      title="Current Ratio"
      headerClassName={styles.header}
      className={styles.invest_sec}
      bodyClassName={styles.body}
    >
      {loading ? (
        <>
          <div className={styles.loading_values}>
            {Array.from({ length: 5 }).map((item, index) => (
              <span key={index} className="shimmer"></span>
            ))}
          </div>
          {Array.from({ length: 5 }).map((item, index) => (
            <div key={index} className={styles.loading_shimmer}>
              <span className={`${styles.box} shimmer`}></span>
              <span className={`${styles.title} shimmer`}></span>
              <span className={`${styles.text} shimmer ms-auto`}></span>
            </div>
          ))}
        </>
      ) : (
        <>
          <div className={styles.color_sec}>
            <div
              style={{ width: `${data?.goldPerc || 0}%` }}
              className={styles.yellow_sec}
            ></div>
            <div
              style={{ width: `${data?.silverPerc || 0}%` }}
              className={styles.gray_sec}
            ></div>
            <div
              style={{ width: `${data?.usdPerc || 0}%` }}
              className={styles.lightblue_sec}
            ></div>
            <div
              style={{ width: `${data?.profitSharingPerc || 0}%` }}
              className={styles.green_sec}
            ></div>
            <div
              style={{ width: `${data?.equityPerc || 0}%` }}
              className={styles.blue_sec}
            ></div>
          </div>
          <div>
            <div className={`${styles.ratio_box} ${styles.gold}`}>
              <div className={styles.gold_text}>
                <span></span>
                <p>
                  Gold STBL (
                  {listData["GoldSTBL"]
                    ? `${Number(data?.goldPerc)?.toFixed(2)}`
                    : "0"}
                  %)
                </p>
              </div>
              <div className={styles.gold_content}>
                <h6>
                  $
                  {!isNaN(
                    Number(
                      `${listData["GoldSTBL"]?.quantity * spotPrice?.goldPrice}`
                    )?.toFixed(2)
                  )
                    ? Number(
                        `${
                          listData["GoldSTBL"]?.quantity * spotPrice?.goldPrice
                        }`
                      )?.toFixed(2)
                    : "0"}
                </h6>
              </div>
            </div>
            <div className={`${styles.ratio_box} ${styles.silver}`}>
              <div className={styles.gold_text}>
                <span></span>
                <p>
                  Silver STBL (
                  {listData["SilverSTBL"]
                    ? `${Number(data?.silverPerc)?.toFixed(2)}`
                    : "0"}
                  %)
                </p>
              </div>
              <div className={styles.gold_content}>
                <h6>
                  $
                  {!isNaN(
                    Number(
                      `${
                        listData["SilverSTBL"]?.quantity *
                        spotPrice?.silverPrice
                      }`
                    )?.toFixed(2)
                  )
                    ? Number(
                        `${
                          listData["SilverSTBL"]?.quantity *
                          spotPrice?.silverPrice
                        }`
                      )?.toFixed(2)
                    : "0"}
                </h6>
              </div>
            </div>
            {listData["Equity"] && (
              <div className={`${styles.ratio_box} ${styles.equity}`}>
                <div className={styles.gold_text}>
                  <span></span>
                  <p>
                    Equity (
                    {listData["Equity"]
                      ? `${Number(data?.equityPerc)?.toFixed(2)}`
                      : "0"}
                    %)
                  </p>
                </div>
                <div className={styles.gold_content}>
                  <h6>
                    $
                    {!isNaN(
                      Number(
                        `${listData["Equity"]?.quantity * equityPrice?.price}`
                      )?.toFixed(2)
                    )
                      ? Number(
                          `${
                            listData["Equity"]?.quantity * equityPrice?.price
                          }`
                        )?.toFixed(2)
                      : "0"}
                  </h6>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </Card>
  );
};

export default CurrentRatio;